<template>
  <div
    :class="[$style.root, readonly && $style.isReadonly]"
    @click="selectFile"
  >
    <input
      ref="file"
      type="file"
      :class="$style.file"
      @change="handleFileChange"
    />
    <div :class="$style.wrapper" :style="{ paddingTop }">
      <div :class="$style.container">
        <img
          v-if="file || src"
          :src="url || src"
          alt="Upload image"
          :class="$style.img"
        />
        <img
          v-else
          :src="require('@/assets/images/add-picture.svg')"
          alt="Upload icon"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageUpload',

  props: {
    file: {
      type: File,
      default: undefined
    },
    src: {
      type: String,
      default: undefined
    },
    ratio: {
      type: Array,
      default: () => [1, 1]
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    paddingTop() {
      return (this.ratio[1] / this.ratio[0]) * 100 + '%'
    },

    url() {
      if (!this.file) return null
      return URL.createObjectURL(this.file)
    }
  },

  methods: {
    selectFile() {
      if (!this.readonly) this.$refs.file.click()
    },

    handleFileChange(e) {
      const files = e.target.files

      this.$emit('update:file', files[0])

      e.target.value = ''
    }
  }
}
</script>

<style lang="scss" module>
.root {
  background-color: #d8d8d8;
  cursor: pointer;
  overflow: hidden;

  &.isReadonly {
    cursor: default;
  }
}

.wrapper {
  position: relative;
}

.container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file {
  display: none;
}

.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
